// execCommand('insertText')로 브라우저 undo stack에 기록하는 textarea 포맷 삽입 헬퍼
export function applyFormatToTextarea(textarea, type, currentValue, onChangeCallback) {
    const start = textarea.selectionStart;
    const end   = textarea.selectionEnd;
    const selected = currentValue.substring(start, end);
    let prefix, suffix, cursorOffset;
    if (type === 'code') {
        if (selected.includes('\n') || !selected) { prefix = '```\n'; suffix = '\n```'; cursorOffset = prefix.length; }
        else { prefix = '`'; suffix = '`'; cursorOffset = prefix.length + selected.length + suffix.length; }
    } else {
        prefix = type; suffix = type;
        cursorOffset = prefix.length + selected.length + suffix.length;
    }
    const newText = `${prefix}${selected}${suffix}`;
    textarea.focus();
    textarea.setSelectionRange(start, end);
    const ok = document.execCommand('insertText', false, newText);
    if (!ok) {
        const full = currentValue.substring(0, start) + newText + currentValue.substring(end);
        textarea.value = full;
        onChangeCallback(full);
    }
    setTimeout(() => {
        const newPos = start + cursorOffset;
        textarea.setSelectionRange(newPos, newPos);
    }, 0);
}
